import React, {  Component } from 'react';
import { connect } from 'react-redux';
import {getSearchKeywordSuggestionList} from '../../../redux/actions';

import _ from 'lodash';

import { routes } from '../../../redux/api/routes';
const { getItemsCount } = routes;

class AccountNumberAutoSuggests extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSuggestion: false,
            showSearchLoading: false,
            productName: this.props.value?this.props.value:'',
            productNumberList: null,
            // productCount: 5
        }
    }
    handleChangeProductNumber(event) {
        var self = this;
        var value = event.target.value;
        self.setState({showSearchLoading: false, showSuggestion: false, productName: value, productNumberList: null});
		//Reset error on change of text box
		self.props.onChangeProductNumberTextBox && self.props.onChangeProductNumberTextBox(self.props.itemIndex, value, null, false);
        if(value !== "" && value.length > 2) {
            self.setState({ showSearchLoading: true, showSuggestion: true });
            self.props.getSearchKeywordSuggestionList('requestType=getItems&keyword='+value +'&count='+getItemsCount, (response) => {
				response.responseObject = _.sortBy(response.responseObject, 'sku');
				if(response.responseObject && response.responseObject.length > 5) {
					response.responseObject = _.chunk(response.responseObject, 5)[0];
				}
                self.setState({
                    showSearchLoading: false,
                    showSuggestion: response.status
                });
                var status = false;
                status = _.find(response.responseObject, ["sku", value])?true:false;
                self.state.productName === response.keyword.replace("*","") && self.setState({ productNumberList: response });

                if(self.state.productName.toUpperCase() === response.keyword.toUpperCase().replace("*","") && !response.status) {
                    self.props.updateQuickOrderState(self.props.itemIndex, { status: status, sku: value });
                } else {
                    self.props.updateQuickOrderState(self.props.itemIndex, { status: false, sku: value });
                }
                if(!response.responseObject && self.props.onChangeProductNumberTextBox){
                    self.props.onChangeProductNumberTextBox(self.props.itemIndex, value, null, true);
                }

            });
        }
    }
    filterSpaces(event) {
        if(event.charCode === 32) event.preventDefault();
    }
    handleClickOfSuggest(sku, event) {
        var self = this;
        event.preventDefault();
        this.setState({
            productName: sku,
            showSuggestion: false
        })
        var productDetails = _.find(self.state.productNumberList.responseObject,['sku',sku]);
        productDetails.status = true;
        self.props.updateQuickOrderState(self.props.itemIndex, productDetails, true);
    }
    handleAutoSuggests(flag,event) {
        var self = this,
            value = event.target.value;

        if(self.state.productName !== '' && (self.state.showSearchLoading || !self.state.productNumberList)) {
            event.target.focus();
            return
        }

        setTimeout(function() {
            self.setState({
                showSuggestion: flag
            });
        }, 200);
        if(flag === false){
            if(value === '') {
				self.props.updateProductChangeBlur && self.props.updateProductChangeBlur(self.props.itemIndex, value);
			} else {
				if(self.state.productNumberList && !_.find(self.state.productNumberList.responseObject, ['sku', value])) {
					self.props.onChangeProductNumberTextBox && self.props.onChangeProductNumberTextBox(self.props.itemIndex, value, null, true);
                }
			}
            var productDetails = self.state.productNumberList && _.find(self.state.productNumberList.responseObject,['sku',value.toUpperCase()]);
            if(productDetails) {
                productDetails.status = true;
                self.props.updateQuickOrderState(self.props.itemIndex, productDetails, true);
                self.setState({
                    productName: productDetails.sku
                });
            }
        }
    }

    render() {
        return (
            <div className="product-number-container">
                <div className="product-number-error-msg"><p className="red"><strong>{this.state.productNumberError}</strong></p></div>
                    <input type="text" id="ProdSearchName" name="ProdSearchName"
                        onChange={this.handleChangeProductNumber.bind(this)}
                        className="row_product outsideProdSearchName d-none d-sm-block"
                        onKeyPress={this.filterSpaces.bind(this)}
                        onBlur={this.handleAutoSuggests.bind(this, false)}
                        onFocus={this.handleAutoSuggests.bind(this, true)}
                        style={{width: this.props.width?this.props.width:300}}
                        autoComplete="off"
                        value={this.state.productName}
						size={this.props.size?this.props.size:''}
						placeholder={this.props.placeHolder || ''}
                    />

                    {/*Mobile view*/}
                    <input type="text" id="ProdSearchName" name="ProdSearchName"
                        onChange={this.handleChangeProductNumber.bind(this)}
                        className="row_product outsideProdSearchName fullWidth form-control inputHeight d-block d-sm-none"
                        onKeyPress={this.filterSpaces.bind(this)}
                        onBlur={this.handleAutoSuggests.bind(this, false)}
                        onFocus={this.handleAutoSuggests.bind(this, true)}
                        style={{width: this.props.width?this.props.width:300}}
                        autoComplete="off"
                        value={this.state.productName}
						size={this.props.size?this.props.size:''}
						placeholder={this.props.placeHolder || ''}
                    />
                    {/*end of mobile view*/}
                    <div id="product-number-autocomplete" style={{zIndex: 101}} className={(this.state.showSuggestion && this.state.productName !== ""?`show ${this.props.suggestionClass}`:"hide")}>
						{this.state.showSearchLoading
							?<div><br/><div className="loader">&#160;</div><br/></div>
							:null
						}
                            {!this.state.showSearchLoading && this.state.productNumberList && this.state.productNumberList.responseObject && this.state.productNumberList.status === true && this.state.productNumberList.responseObject.map((item, index) => {
                            return <a tabIndex="-1" key={index} onClick={this.handleClickOfSuggest.bind(this, item.sku)} href="">{item.sku}</a>
                        })}
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
  return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getSearchKeywordSuggestionList: (queryStringParams, callback) => dispatch(getSearchKeywordSuggestionList(queryStringParams, callback)),
});

AccountNumberAutoSuggests = connect(mapStateToProps, mapDispatchToProps)(AccountNumberAutoSuggests);
export default AccountNumberAutoSuggests;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/common/accountNumberAutoSuggests.js